import { ReactNode } from 'react';
import { Button, Stack, Typography } from '@rossum/ui/material';

type ItemWrapperProps = {
  icon: ReactNode;
  label: string;
  isHovered?: boolean;
  onClick?: (e: React.MouseEvent) => void;
  dataCy?: string;
  disabled?: boolean;
};

const ItemWrapper = ({
  icon,
  label,
  isHovered,
  dataCy,
  onClick,
  disabled,
}: ItemWrapperProps) => (
  <Button
    onClick={onClick}
    disabled={disabled}
    data-cy={dataCy}
    sx={{
      px: 1.5,
      py: 0.88,
      height: '100%',
      borderRadius: 0,
      color: theme => theme.palette.primary.contrastText,
      backgroundColor: theme =>
        isHovered ? theme.palette.primary.dark : 'transparent',
      ':hover': {
        backgroundColor: theme => theme.palette.primary.dark,
      },
    }}
  >
    <Stack justifyContent="center" alignItems="center" spacing={0.25}>
      {icon}
      <Typography variant="caption" whiteSpace="nowrap">
        {label}
      </Typography>
    </Stack>
  </Button>
);

export default ItemWrapper;
